import {
  Alert,
  AlertIcon,
  Box,
  Center,
  CloseButton,
  Flex,
  Heading,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import { useBuilding } from "../../data/mazemap.api";
import { useFocusOnFeature } from "../../hooks/useFocusOnFeature";
import BackButton from "../BackButton";
import BottomSheetWrapper from "../BottomSheetWrapper";
import DirectionsButton from "./DirectionsButton";

type Props = {
  id: string;
};

const BuildingSearchResult = ({ id }: Props) => {
  const { data, isLoading, isError } = useBuilding(parseInt(id));
  const { lng, lat } = useFocusOnFeature(data);

  return (
    <BottomSheetWrapper>
      {isLoading ? (
        <Center p={8}>
          <Spinner />
        </Center>
      ) : isError ? (
        <Center p={8}>
          <Alert status="error">
            <AlertIcon />
            Could not find a building with ID "{id}".
          </Alert>
        </Center>
      ) : data ? (
        <Box position="relative" p={5}>
          <BackButton />
          <Box mb={3}>
            <Heading size="md">{data.properties.name}</Heading>
            <Text opacity={0.7}>{data.properties.floors.length} floors</Text>
          </Box>
          <Flex gap={2} alignItems="center" flexWrap="wrap">
            {lng && lat && <DirectionsButton lng={lng} lat={lat} />}
          </Flex>
        </Box>
      ) : null}
    </BottomSheetWrapper>
  );
};

export default BuildingSearchResult;
